import { PermissionsType } from '@/types/permissions'
import { UserType } from '@/types/user'

type PermissionKey = keyof PermissionsType

type AccessRule = {
  requireAuth?: boolean
  anyPermissions?: PermissionKey[]
  allPermissions?: PermissionKey[]
  typeUsers?: string[]
  typeCargos?: string[]
}

export function hasAccess(user: Partial<UserType> | null | undefined, rule?: AccessRule): boolean {
  if (!rule) return true
  if (!user) return !rule.requireAuth

  if (rule.typeUsers?.length && !rule.typeUsers.includes(String(user.typeUser ?? ''))) {
    return false
  }

  if (rule.typeCargos?.length && !rule.typeCargos.includes(String(user.typeCargo ?? ''))) {
    return false
  }

  const permissions = user.permissions ?? ({} as Partial<PermissionsType>)

  if (rule.allPermissions?.length && !rule.allPermissions.every(permission => Boolean(permissions[permission]))) {
    return false
  }

  if (rule.anyPermissions?.length && !rule.anyPermissions.some(permission => Boolean(permissions[permission]))) {
    return false
  }

  return true
}

export function isAdmin(user: Partial<UserType> | null | undefined): boolean {
  return hasAccess(user, { requireAuth: true, typeUsers: ['ADMIN'] })
}

export function isAdminCeo(user: Partial<UserType> | null | undefined): boolean {
  return hasAccess(user, { requireAuth: true, typeUsers: ['ADMIN'], typeCargos: ['CEO'] })
}
